import React from 'react';
import styled from 'styled-components';
import { Image } from 'UI-Dash-Commons-UI';

const download = require( '../images/download.svg' );

type DownloadCardProps =
    {
        displayName?: string,
        downloadUrl?: string,
        version?: string,
        newWindow?: boolean,
    };

const DownloadCard: React.FunctionComponent<DownloadCardProps> = ( props: DownloadCardProps ) =>
    (
        <DownloadCardWrapper
            href={props.downloadUrl}
            target={props.newWindow ? '_blank' : ''}
            rel={props.newWindow ? 'noopener noreferrer' : ''}
        >
            <DownloadImage
                alt={'download'}
                src={download}
            />

            <DownloadDescription>
                <DownloadName>
                    {props.displayName}
                </DownloadName>

                <DownloadVersion>
                    {props.version}
                </DownloadVersion>
            </DownloadDescription>
        </DownloadCardWrapper>
    );

export default DownloadCard;

const DownloadCardWrapper = styled.a`
  display: inline-block;

  min-width: 170px;
  width: fit-content;
  height: 60px;

  margin-right: 30px;

  text-decoration: none;
  border: 1px solid ${props => props.theme.colors.blueLight};

  transition: transform 300ms ease-out;

  :hover {
    transform: translate(0px, -3px);
    background: ${props => props.theme.colors.backgroundBlueLight};
  }
`;

const DownloadImage = styled( Image )`
  display: inline-block;

  margin: 8px;
`;

const DownloadDescription = styled.div`
  display: inline-block;
  padding-right: 10px;
`;

const DownloadName = styled.div`
  display: block;

  padding-top: 12px;

  font-family: ${props => props.theme.fonts.regular};
  font-size: 16px;

  color: ${props => props.theme.colors.anchorText};
`;

const DownloadVersion = styled.div`
  display: block;

  padding-top: 4px;

  font-family: ${props => props.theme.fonts.regular};
  font-size: 12px;

  color: ${props => props.theme.colors.silver};
`;
